export default __webpack_public_path__ + "static/media/newAnimation.de46bd18.gif";